(function() {
    'use strict';

    let paramsDefault;

    function initWidget(params) {
        paramsDefault = params;
        if (document.readyState === "loading") {
            document.addEventListener("DOMContentLoaded", createElements);
        } else {
            createElements();
        }
    }

    function createElements() {
        const body = document.body;
        const wpp = document.createElement('div');
        wpp.id = "whatsapp-widget";
        wpp.className = 'whatsapp-widget';
        body.appendChild(wpp);

        const mainWhatsappWidget = document.getElementById('whatsapp-widget');

        const strTarget = `
            <a href="#" id="whatsapp-widget-target" class="whatsapp-widget-target pulse">
                <img id="whatsapp-widget-icon" class="whatsapp-widget-icon" src="${paramsDefault.pluginUrl}assets/img/whatsapp-icon.png" alt="WhatsApp"/>
            </a>`;

        const strChat = `
            <div id="whatsapp-widget-chat" class="whatsapp-widget-chat" style="display: none !important;">
                <div id="whatsapp-widget-chat-header" class="whatsapp-widget-chat-header" style="background: ${paramsDefault.optionsPopup.background} !important; color: ${paramsDefault.optionsPopup.color} !important;">
                    <div id="whatsapp-widget-close" class="whatsapp-widget-close">✖</div>
                    <div class="bot">
                        <div class="bot-img">
                            <img src="${paramsDefault.optionsBot.image}" alt="${paramsDefault.optionsBot.name}"/>
                        </div>
                        <div class="bot-info">
                            <div class="name">${paramsDefault.optionsBot.name}</div>
                            <div class="status">En ligne</div>
                        </div>
                    </div>
                </div>
                <div class="whatsapp-widget-chat-content">
                    <div class="message">
                        <div class="header">${paramsDefault.optionsBot.name}</div>
                        <div class="msg">${paramsDefault.optionsChat.message || paramsDefault.optionsBot.messageDefault}</div>
                        <div class="date">${timeNow()}</div>
                    </div>
                </div>
                <div class="whatsapp-widget-chat-footer">
                    <div class="input-container">
                        <input type="text" placeholder="Écrire un message" id="whatsapp-widget-chat-input" class="whatsapp-widget-chat-input" />                        
                    </div>
                    <a href="#" id="whatsapp-widget-open-modal" class="whatsapp-widget-open-modal">   
                        ${paramsDefault.optionsChat.text}       
                    </a>
                </div>
            </div>`;

        mainWhatsappWidget.innerHTML = strTarget + strChat;

        setEvents();
    }

    function setEvents() {
        const widgetChat = document.getElementById("whatsapp-widget-chat");
        const widgetTarget = document.getElementById("whatsapp-widget-target");
        const closeBtn = document.getElementById("whatsapp-widget-close");
        const openModalBtn = document.getElementById("whatsapp-widget-open-modal");

        if (widgetTarget) {
            widgetTarget.addEventListener("click", (e) => {
                e.preventDefault();
                toggleChat();
            });
        }

        if (closeBtn) {
            closeBtn.addEventListener("click", () => {
                widgetChat.style.setProperty('display', 'none', 'important');
            });
        }

        if (openModalBtn) {
            openModalBtn.addEventListener("click", (e) => {
                e.preventDefault();
                openWhatsAppModal();
                widgetChat.style.setProperty('display', 'none', 'important');
            });
        }
    }

    function toggleChat() {
        const widgetChat = document.getElementById("whatsapp-widget-chat");
        const currentDisplay = widgetChat.style.getPropertyValue('display');

        if (currentDisplay === 'none' || currentDisplay === '') {
            widgetChat.style.setProperty('display', 'flex', 'important');
        } else {
            widgetChat.style.setProperty('display', 'none', 'important');
        }
    }

    function formatPhoneNumber(phone) {
        let formattedPhone = phone.replace(/\D/g, '');

        // Supprimer les zéros initiaux
        formattedPhone = formattedPhone.replace(/^0+/, '');

        // Supprimer le signe plus initial s'il existe
        formattedPhone = formattedPhone.replace(/^\+/, '');

        // Récupérer le code pays depuis les paramètres ou utiliser '33' par défaut
        const countryCode = paramsDefault.optionsChat.country_code || '33';

        // Ajouter le code pays s'il n'est pas déjà présent
        if (!formattedPhone.startsWith(countryCode)) {
            formattedPhone = countryCode + formattedPhone;
        }

        return formattedPhone;
    }

    function openWhatsAppModal() {
        const messageInput = document.getElementById("whatsapp-widget-chat-input");
        const message = messageInput.value || paramsDefault.optionsChat.message;
        const rawPhone = paramsDefault.optionsChat.phone;
        const phone = formatPhoneNumber(rawPhone);

        const url = `https://api.whatsapp.com/send?phone=${encodeURIComponent(phone)}&text=${encodeURIComponent(message)}`;

        window.open(url, '_blank');
    }

    function timeNow() {
        return new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    }

    if (typeof whatsappWidgetConfig !== 'undefined') {
        initWidget(whatsappWidgetConfig);
    } else {
        console.error("Configuration du WhatsApp Widget introuvable");
    }
})();
